<template>
  <transition :name="transitionName" :mode="transitionMode">
    <slot />
  </transition>
</template>

<script>
  const DEFAULT_TRANSITION = 'fade';
  const DEFAULT_TRANSITION_MODE = 'out-in';

  export default {
    inject: {
      $validator: '$validator',
    },
    name: 'TransitionPage',
    data() {
      return {
        prevHeight: 0,
        transitionName: DEFAULT_TRANSITION,
        transitionMode: DEFAULT_TRANSITION_MODE,
        transitionEnterActiveClass: '',
      };
    },
    methods: {
      // beforeLeave(element) {
      //   this.prevHeight = getComputedStyle(element).height;
      // },
      // enter(element) {
      //   const { height } = getComputedStyle(element);
      //   element.style.height = this.prevHeight;
      //   setTimeout(() => {
      //     element.style.height = height;
      //   });
      // },
      // afterEnter(element) {
      //   element.style.height = "auto";
      // }
    },
  };
</script>

<style lang="scss" scoped>
  $flowTime: 0.3s;
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity $flowTime;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
